import { observer } from 'mobx-react-lite';

import {
  IonText,
  IonRippleEffect,
  IonSkeletonText,
  IonImg
} from '@ionic/react';

import { getUrlFromPath } from 'libs/helpers/helper.lib';
import classes from './style.module.scss';
import videoFeedStore from 'stores/video-feed.store';

const Stories = ({ match, history }) => {
  const videoFeeds = videoFeedStore.getObjects();
  const isLoading = videoFeedStore.getIsLoading();

  return (
    <div className={classes.mainContainer}>
      <div>
        <IonText className='big'>Stories</IonText>
      </div>
      <div className={classes.content}>
        {!isLoading ? (
          videoFeeds.map((videoFeed, index) => (
            <div
              key={videoFeed.id}
              className={`ion-activatable ripple-parent ${classes.videoImageContainer}`}
              onClick={(e) => {
                e.stopPropagation();
                history.push(`/stories?slide=${index}`);
              }}
            >
              <IonImg
                className={classes.videoImage}
                src={getUrlFromPath(videoFeed.video_cover)}
                alt='Stories'
              />
              <IonRippleEffect></IonRippleEffect>
            </div>
          ))
        ) : (
          <>
            <div className={classes.videoImageContainer}>
              <IonSkeletonText animated className={classes.videoImage} />
            </div>
            <div className={classes.videoImageContainer}>
              <IonSkeletonText animated className={classes.videoImage} />
            </div>
            <div className={classes.videoImageContainer}>
              <IonSkeletonText animated className={classes.videoImage} />
            </div>
            <div className={classes.videoImageContainer}>
              <IonSkeletonText animated className={classes.videoImage} />
            </div>
            <div className={classes.videoImageContainer}>
              <IonSkeletonText animated className={classes.videoImage} />
            </div>
            <div className={classes.videoImageContainer}>
              <IonSkeletonText animated className={classes.videoImage} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default observer(Stories);
